import React, { useState, useEffect, useCallback, useRef } from 'react'
import {
  Button,
  Input,
  Select,
  Table,
  Checkbox,
  Form,
  Row,
  Col,
  DatePicker,
} from 'antd'
import 'aos/dist/aos.css'
import axios from 'axios'
import { toast } from 'react-toastify'
import { Option } from 'antd/es/mentions'
import { PlusOutlined } from '@ant-design/icons'
import { TemperMasterGet } from '../../AllAPI/MasterAPI/ProductionMasterApi'
import {
  DiaMasterGet,
  DieNameMasterGet,
} from '../../AllAPI/MasterAPI/DiesMasterApi'
import { GetCustomerMaster } from '../../AllAPI/MasterAPI/SalesMasterApi'
import { GetAlloyMaster, GetPressMaster } from '../../AllAPI/MasterAPI/GeneralMasterApi'
import {
  ClosePendingOrder,
  GetPendingOrderList,
  PendingOrderHistory,
  SavePendingOrder,
  UpdateDiaNumberPendingOrder,
} from '../../AllAPI/ProductionOrderAPI/ProductionOrderApi'
import DataTable from 'react-data-table-component'
import TextArea from 'antd/es/input/TextArea'
import { Tooltip } from 'react-bootstrap'

// import "../../MainCSS.css";

const PendingOrderSummary = () => {
  const commonHeaders = {
    headers: {
      createdBy: 1,
      updatedBy: 2,
      userIp: '',
      userLat: '',
      userLong: '',
      deviceSign: '',
    },
  }
  // Fetch Pending Order Summary, Customer and Item Names
  let isPendingSummaryFetched = false
  useEffect(() => {
    if (isPendingSummaryFetched) return
    // fetchAlloy();
    // fetchCustomer();
    // fetchItemName();
    // fetchTemperName();
    fetchPendingSummary();
    fetchPress();
   
    
    isPendingSummaryFetched = true
  }, [])

  const [errors, setErrors] = useState({
    stockId: '',
    itemName: '',
    alloy: '',
    temper: '',
    customerName: '',
    Pcs: '',
    Qty: '',
    weightRange: '',
    length: '',
    unit: '',
  })
  const [pageSize1, setPageSize1] = useState(10)
  const [filteredData1, setFilteredData1] = useState([])
  const [pageSize, setPageSize] = useState(10)
  const [filteredData, setFilteredData] = useState([])
  const [originalData, setOriginalData] = useState([])
  const [currentPage1, setCurrentPage1] = useState(1)
  const [totalEntries1, setTotalEntries1] = useState(0)

  const [currentPage, setCurrentPage] = useState(1)
  const [totalEntries, setTotalEntries] = useState(0)
  const [pendingOrderData, setPendingOrderData] = useState([])
    const [pendingOrderHistory, setPendingOrderHistory] = useState([])
  const [stockId, setStockId] = useState('')
  const [itemName, setItemName] = useState('')
  const [alloy, setAlloy] = useState('')
  const [temper, setTemper] = useState('')
  const [customerName, setCustomerName] = useState('')
  const [Pcs, setPcs] = useState('')
  const [Qty, setQty] = useState('')
  const [weightRange, setWeightRange] = useState('')
  const [length, setLength] = useState('')
  const [unit, setUnit] = useState('')
  const [allAlloy, setAllAlloy] = useState([])
  const [allCustomers, setAllCustomers] = useState([])
  const [allItems, setAllItems] = useState([])
  const [allTemper, setAllTemper] = useState([])
  const [diaOptions, setDiaOptions] = useState([])
  const [pressOptions, setPressOptions] = useState([])

  const [tempRemarks, setTempRemarks] = useState({})
  const [searchValue, setSearchValue] = useState('');
   const [searchValue1, setSearchValue1] = useState('');
  const [tempAdjustmentQty, setTempAdjustmentQty] = useState({});
const [tempAdjustmentPcs, setTempAdjustmentPcs] = useState({});
const [approvedItems, setApprovedItems] = useState(new Set());
const [selectAll, setSelectAll] = useState(false);
const [selectedDate, setSelectedDate] = useState(null);


  const [tempPressNumbers, setTempPressNumbers] = useState({});


  const [submitButton, setSubmitButton] = useState(true)
  const [updateButton, setUpdateButton] = useState(false)
  const dateFormatList = ['DD/MM/YYYY', 'DD/MM/YY', 'DD-MM-YYYY', 'DD-MM-YY']

  const goodTypesOptions = [
    { value: '1', label: 'F.T' },
    { value: '2', label: 'MM' },
    { value: '3', label: 'Inch' },
  ]
  const diaNumberOptions = [
    { value: '1', label: '5' },
    { value: '2', label: '7' },
     { value: '3', label: '5,7' },
  ]

  //======Search data from table===============
 

  // const handleSearch = (value) => {
  //   const filtered = pendingOrderData.filter((item) =>
  //     Object.values(item).some((val) =>
  //       val.toString().toLowerCase().includes(value.toLowerCase())
  //     )
  //   );
  //   setFilteredData(filtered);
  //   setTotalEntries(filtered.length); // Update total entries count after filtering
  //   setCurrentPage(1);
  // };
  const handleSearch = (value) => {
    setSearchValue(value); // Track current input
  
    const filtered = pendingOrderData.filter((item) =>
      Object.values(item).some((val) =>
        (val ?? '').toString().toLowerCase().includes(value.toLowerCase())
      )
    );
  
    setFilteredData(filtered);
    setTotalEntries(filtered.length);
    setCurrentPage(1);
  };
   const handleSearch1 = (value) => {
    setSearchValue1(value); // Track current input
  
    const filtered = pendingOrderHistory.filter((item) =>
      Object.values(item).some((val) =>
        (val ?? '').toString().toLowerCase().includes(value.toLowerCase())
      )
    );
  
    setFilteredData1(filtered);
    setTotalEntries1(filtered.length);
    setCurrentPage1(1);
  };
  //==========Pagination=======================
const handlePageSizeChange = (value) => {
  setPageSize(value);
  setCurrentPage(1);
};
  // ==============Get table data================

  let isError = false
  // const fetchPendingSummary = async () => {
  //   try {
  //     const response = await axios.get(GetPendingOrderList, commonHeaders)
  //     if (response.data !== null) {
  //       setPendingOrderData(response.data)
  //       setFilteredData(response.data)
  //       setTotalEntries(response.data.length) // Set the total number of entries
  //       const data = response.data // assume this is your pending orders array
  //       const initialRemarks = {}
  //       data.forEach((item) => {
  //         initialRemarks[item.id] = item.remark || ''
  //        // if remark is null, fallback to empty string
  //       })
  //       setTempRemarks(initialRemarks)
  //     }
  //     else{
  //       toast.warn("No data available!!");
  //     }
  //   } catch (error) {
  //     if (!isError) {
  //       console.error('Error fetching data:', error)
  //       toast.error('Failed to fetch  data')
  //       isError = true // Set the flag to prevent double toast
  //     }
  //   }
  // }
  const fetchPendingSummary = async () => {
  try {
    const response = await axios.get(GetPendingOrderList, commonHeaders);
    
    if (response.data && response.data.length > 0) {
      // Data is not empty
      setPendingOrderData(response.data);
      setFilteredData(response.data);
      setTotalEntries(response.data.length); // Set the total number of entries
      
      const data = response.data; // assume this is your pending orders array
      const initialRemarks = {};
      data.forEach((item) => {
        initialRemarks[item.id] = item.remark || ''; // If remark is null, fallback to empty string
      });
      setTempRemarks(initialRemarks);
    } else {
      // Data is either null or empty
      toast.warn("No pending orders available!");
      setPendingOrderData([]);  // Reset the data
      setFilteredData([]);      // Reset the filtered data
      setTotalEntries(0);       // Reset total entries count
    }
  } catch (error) {
    if (!isError) {
      console.error('Error fetching data:', error);
      toast.error('Failed to fetch data');
      isError = true; // Set the flag to prevent double toast
    }
  }
}

    const fetchPendingHistory = async (date) => {
    try {
      const response = await axios.get(`${PendingOrderHistory}?createdTime=${date}`, commonHeaders)
  if (response.data && response.data.length > 0) {
            setPendingOrderHistory(response.data)
         setFilteredData1(response.data)
        setTotalEntries1(response.data.length)
      }
       else {
      // Data is either null or empty
      toast.warn("No pending orders history available!");
      setPendingOrderHistory([]);  // Reset the data
      setFilteredData1([]);      // Reset the filtered data
      setTotalEntries1(0);       // Reset total entries count
    }
    } catch (error) {
      if (!isError) {
        console.error('Error fetching data:', error)
        toast.error('Failed to fetch  data')
        isError = true // Set the flag to prevent double toast
      }
    }
  }
  
    const fetchPress = async () => {
      try {
        const response = await axios.get(GetPressMaster, commonHeaders)
        // if (response.data !== null) {
        //   setPressOptions(response.data)
          
          
        // }
         if (response.data !== null) {
      const transformedPressOptions = response.data.map((press) => ({
        id: press.id,
        pressName: press.pressName,
        compatibleDiaNumbers: press.diaMasterList.map(dia => dia.id),
      }))

      setPressOptions(transformedPressOptions)
    }
      } catch (error) {
        if (!isError) {
          console.error('Error fetching Press:', error)
          toast.error('Failed to fetch Press data')
          isError = true
        }
      }
    }
  // const fetchDiaMaster = async () => {
  //   try {
  //     const response = await axios.get(DiaMasterGet, commonHeaders)
  //     if (response.data !== null) {
  //       setDiaOptions(response.data)
  //     }
  //   } catch (error) {
  //     if (!isError) {
  //       console.error('Error fetching Dia Master data:', error)
  //       toast.error('Failed to fetch Dia Master data')
  //       isError = true // Set the flag to prevent double toast
  //     }
  //   }
  // }
  

  // const fetchAlloy = async () => {

  //   try {
  //     const response = await axios.get(GetAlloyMaster,commonHeaders);
  //     if (response.data !== null) {
  //       setAllAlloy(response.data);
  //     }
  //   } catch (error) {
  //     if (!isError) {
  //       console.error("Error fetching Alloy:", error);
  //       toast.error("Failed to fetch Alloy data");
  //       isError = true; // Set the flag to prevent double toast
  //     }
  //   }
  // };
  // const fetchCustomer = async () => {

  //   try {
  //     const response = await axios.get(GetCustomerMaster,commonHeaders);
  //     if (response.data !== null) {
  //       setAllCustomers(response.data);
  //     }
  //   } catch (error) {
  //     if (!isError) {
  //       console.error("Error fetching Customers:", error);
  //       toast.error("Failed to fetch Customers data");
  //       isError = true; // Set the flag to prevent double toast
  //     }
  //   }
  // };

  // const fetchItemName = async () => {

  //   try {
  //     const response = await axios.get(DieNameMasterGet,commonHeaders);
  //     if (response.data !== null) {
  //       setAllItems(response.data);
  //     }
  //   } catch (error) {
  //     if (!isError) {
  //       console.error("Error fetching Item:", error);
  //       toast.error("Failed to fetch Item data");
  //       isError = true; // Set the flag to prevent double toast
  //     }
  //   }
  // };
  // const fetchTemperName = async () => {

  //   try {
  //     const response = await axios.get(TemperMasterGet,commonHeaders);
  //     if (response.data !== null) {
  //       setAllTemper(response.data);
  //     }
  //   } catch (error) {
  //     if (!isError) {
  //       console.error("Error fetching Temper:", error);
  //       toast.error("Failed to fetch Temper data");
  //       isError = true; // Set the flag to prevent double toast
  //     }
  //   }
  // };

const toggleItemSelection = (id, isChecked) => {
  setApprovedItems(prev => {
    const newSet = new Set(prev);
    if (isChecked) {
      newSet.add(id);
    } else {
      newSet.delete(id);
    }
    setSelectAll(newSet.size === pendingOrderData.length); // update "Select All" checkbox
    return newSet;
  });
};
const handleSelectAll = (e) => {
  const isChecked = e.target.checked;
  setSelectAll(isChecked);
  if (isChecked) {
    const allIds = new Set(pendingOrderData.map(item => item.id));
    setApprovedItems(allIds);
  } else {
    setApprovedItems(new Set());
  }
};
const handleBulkUpdate = async () => {
  // Filter selected records
  const selectedRecords = pendingOrderData.filter(item => approvedItems.has(item.id));

  // Prepare the list of updates to send
  const updates = selectedRecords.map(record => {
    const latestRecord = pendingOrderData.find(item => item.id === record.id);

    // Get updated remark from tempRemarks or existing remark
    const updatedRemark = tempRemarks[record.id] ?? latestRecord.remark ?? '';
    const pressNameId = tempPressNumbers[record.id] ?? latestRecord.pressNameId ?? '';
    const updatedQty = tempAdjustmentQty[record.id] ?? latestRecord.adjustedQty ?? '';
    const updatedPcs = tempAdjustmentPcs[record.id] ?? latestRecord.adjustedPcs ?? '';
    const diaNumber = latestRecord?.diaNumber ?? ''; // Get diaNumber (if available)

    // Construct the update object
    const update = {
      id: record.id,
      remark: updatedRemark,
      pressNameId: pressNameId,
      adjustedPcs: updatedPcs,
      adjustedQty: updatedQty
    };

    // Include diaNumber only if it has a valid value
    if (diaNumber) {
      update.diaNumber = diaNumber;
    }

    return update;
  });

  if (updates.length > 0) {
    try {
      // Send PUT request with the updates as the body
      const response = await axios.put(
        UpdateDiaNumberPendingOrder,
        updates, // Send the array of updated records
        commonHeaders
      );

      if (response.status === 200) {
        toast.success('Updated successfully.');
        console.log('API Response:', response.data);

        // Optional: Clear selection after update
        setApprovedItems(new Set());
        setSelectAll(false);
        fetchPendingSummary(); // Refresh the table
      } else {
        toast.error('Failed to update Dia Numbers and Remarks.');
      }
    } catch (error) {
      console.error('Error updating Dia Numbers and Remarks:', error);
      toast.error('Failed to update Dia Numbers and Remarks.');
    }
  } else {
    toast.warning('No items selected for update.');
  }
};

 

  // const handleUpdate = async (record) => {
  //   // Find the latest record from pendingOrderData
  //   const latestRecord = pendingOrderData.find(item => item.id === record.id);
  
  //   // Get updated remark from tempRemarks or existing remark
  //   const updatedRemark = tempRemarks[record.id] ?? latestRecord.remark ?? '';
  //   const pressNameId = tempPressNumbers[record.id] ?? latestRecord.pressNameId?? '';
  //     const updatedQty = tempAdjustmentQty[record.id] ?? latestRecord.adjustedQty ?? '';
  // const updatedPcs = tempAdjustmentPcs[record.id]??latestRecord.adjustedPcs ?? '';


  
  //   // Get updated diaNumberId from the latest record
  //   const diaNumber = latestRecord?.diaNumber ?? '';
  
  //   try {
  //     let url = `${UpdateDiaNumberPendingOrder}?id=${record.id}&remark=${encodeURIComponent(updatedRemark)}&pressNameId=${pressNameId}&adjustedPcs=${updatedPcs}&adjustedQty=${updatedQty}&diaNumber=${diaNumber}`;
  
  //     // Only add diaNumberId if available
  //     // if (diaNumber) {
  //     //   url += `&diaNumber=${diaNumber}`;
  //     // }
  
  //     // Send PUT request
  //     const response = await axios.put(url, {}, commonHeaders);
  
  //     toast.success('Updated successfully.');
  //     console.log('API Response:', response.data);
  
  //     // Clear the remark input for that record after successful update
  //     setTempRemarks((prev) => {
  //       const { [record.id]: _, ...rest } = prev;
  //       return rest;
  //     });
  
  //     fetchPendingSummary(); // Refresh your table
  //   } catch (error) {
  //     console.error('Error updating Dia Number and Remark:', error);
  //     toast.error('Failed to update Dia Number and Remark.');
  //   }
  // };
  
  const handlePressNumberChange = (selectedValue, row) => {
    setTempPressNumbers((prev) => ({
      ...prev,
      [row.id]: selectedValue,
    }));
  };
  
  const [rowsWithSubDia, setRowsWithSubDia] = useState(new Set());
const handleDiaSubSelection = (selectedSubDia, record) => {
  setPendingOrderData((prevData) =>
    prevData.map((item) =>
      item.id === record.id
        ? { ...item, diaNumber: selectedSubDia }
        : item
    )
  );

  // Ensure the row remains in dropdown mode
  setRowsWithSubDia((prev) => new Set(prev).add(record.id));
};

  // const handleDiaSubSelection = (selectedSubDia, record) => {
  //   setPendingOrderData((prevData) => {
  //     const updatedData = prevData.map((item) =>
  //       item.id === record.id
  //         ? { ...item, diaNumber: selectedSubDia } // Add/update sub-dia field
  //         : item
  //     );
  
  //     console.log('Updated Data after Sub-Dia change:', updatedData);
  //     return updatedData;
  //   });
  // };
  //const handleDiaChange = (selectedDiaNumberId, record) => {
  //   setPendingOrderData((prevData) => {
  //     const updatedData = pr.map((item) =>
  //       item.id === record.id
  //         ? { ...item, diaNumberId: selectedDiaNumberId }
  //         : item,
  //     )
  //     console.log('Updated Data after Dia change:', updatedData)
  //     return updatedData
  //   })
  // }

  const inputRef = useRef({})

  const handleRemarkChange = (value, record) => {
    setTempRemarks((prev) => ({
      ...prev,
      [record.id]: value,
    }))
    // Keep the input focus manually
    inputRef.current[record.id]?.focus()
  }
  const handleAdjustmentQtyChange = (value, row) => {
  setTempAdjustmentQty((prev) => ({ ...prev, [row.id]: value }));
};

const handleAdjustmentPcsChange = (value, row) => {
  setTempAdjustmentPcs((prev) => ({ ...prev, [row.id]: value }));
};


  // const columns1 = [
  //   {
  //     title: "Sr.No.",
  //     dataIndex: "",
  //     key: "index",
  //     render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
  //   },
  //   {
  //     title: "Pending Order Id",
  //     dataIndex: "pendingOrder",
  //     key: "pendingOrder",
  //   },
  //   {
  //     title:"Order No.",
  //     dataIndex: "orderNumber",
  //     key: "orderNumber",
  //   },

  //   {
  //     title:"Item Name",
  //     dataIndex: "dieName",
  //     key: "dieName",
  //   },
  //   {
  //    title:"Alloy",
  //    dataIndex: "alloyname",
  //    key: "alloyname",
  //  },
  //  {
  //     title:"Temper",
  //     dataIndex: "temperName",
  //     key: "temperName",
  //   },
  //   {
  //     title:"Weight",
  //     dataIndex: "weight",
  //     key: "weight",
  //   },
  //   {
  //     title:"Length",
  //     dataIndex: "length",
  //     key: "length",
  //   },
  //   {
  //     title:"Pcs",
  //     dataIndex: "pcs",
  //     key: "pcs",
  //   },
  //   {
  //     title:"Qty",
  //     dataIndex: "qty",
  //     key: "qty",

  //   },
  //   {
  //     title:"Customer Name",
  //     dataIndex: "customerName",
  //     key: "customerName",
  //   },
  //   {
  //     title: "Dia No.",
  //     key: "diaNumberId",
  //     render: (text, record) => (
  //       <Select
  //         mode="multiple" // Enable multiple selection
  //         placeholder="Select Dia"
  //         style={{ width: 200 }} // Adjust width as needed
  //         value={record.diaNumberId || []} // Ensure it's an array
  //         onChange={(selectedDiaNumberIds) => handleDiaChange(selectedDiaNumberIds, record)}
  //         optionFilterProp="children"
  //       >
  //         {diaOptions.map((dia) => (
  //           <Option key={dia.id} value={dia.id}>
  //             {dia.diaNumber}
  //           </Option>
  //         ))}
  //       </Select>
  //     ),
  //   },

  // {
  //    title:" Prod. Pcs",
  //   dataIndex: "productionPcs",
  //   key: "productionPcs",},

  //   {
  //      title:"Prod. Qty",
  //     dataIndex: "productionQty",
  //     key: "productionQty",},
  //     {
  //        title:"Rack No.",
  //       dataIndex: "rackNumber",
  //       key: "rackNumber",},
  //       {
  //         title:" Pending Order Pcs",
  //         dataIndex:"pendingOrderPcs",
  //         key: "pendingOrderPcs",
  //       },
  //       {
  //         title:"Pending Order Qty",
  //         dataIndex: "pendingOrderQty",
  //         key: "pendingOrderQty",
  //       },
  //       {
  //         title:"Ageging Status",
  //         dataIndex: "agegingStatus",
  //         key: "agegingStatus",
  //       },
  //       {
  //         title:"Packing Pcs",
  //         dataIndex: "packingPcs",
  //         key: "packingPcs",
  //       },
  //       {
  //         title:"Packing Qty",
  //         dataIndex: "packingQty",
  //         key: "packingQty",
  //       },
  //       {
  //         title: "Remark",
  //         key: "remark",
  //         render: (text, record) => (
  //           <Input

  //             placeholder="Enter remark"
  //             value={tempRemarks[record.id] !== undefined ? tempRemarks[record.id] : record.remark ?? ""}
  //             onChange={(e) => handleRemarkChange(e.target.value, record)}
  //             style={{ width: 180 }}
  //           />
  //         ),
  //       },
  //   {
  //     title: "Actions",
  //     key: "actions",
  //     render: (text, record) => (

  //       <div>
  //        <Button
  //     type="primary"
  //     style={{ fontSize: "12px", marginLeft: "10px" }}
  //     onClick={() => handleUpdate(record)}
  //   >
  //     Update
  //   </Button>

  //         <Button
  //           type="submit"
  //           className="SubmitBtn"

  //           style={{ fontSize: "12px", backgroundColor: "red", color:"white",marginLeft: "10px" }}
  //           // onClick={() => handleDeleteData(record)}
  //         >
  //          Close
  //         </Button>
  //       </div>
  //     ),
  //   },
  // ];
  const columns1 = [
    {
      name: 'Sr.No.',
      selector: (row, index) => (currentPage - 1) * pageSize + index + 1,
      width: '80px',
    },
    {
      // name: 'Pending Order Id',
      name: <div>Pending Order<br />ID</div>,

      selector: (row) => row.pendingOrder,
      sortable: true,
         wrap: true, 
    },
    {
      name: 'Order No.',
      selector: (row) => row.orderNumber,
      sortable: true,
    },
    {
      name: 'Item Name',
      selector: (row) => row.dieName,
      sortable: true,
         wrap: true, 
    },
    // {
    //   name: 'Item Details',
    //   cell: (row) => {
    //     const unitOption = goodTypesOptions.find((opt) => opt.value === String(row.unit));
    //     const unitLabel = unitOption ? unitOption.label : '';
    //     return (
    //       <div>
    //         <div><strong>Alloy:</strong> {row.alloyname}</div>
    //         <div><strong>Temper:</strong> {row.temperName}</div>
    //         <div><strong>Weight:</strong> {row.weight}</div>
    //         <div><strong>Length:</strong> {row.length}</div>
    //         <div><strong>Unit:</strong> {unitLabel}</div>
    //         <div><strong>Pcs:</strong> {row.pcs}</div>
    //       </div>
    //     );
    //   },
    //   width: '150px', // Adjust width as needed
    // },
    {
      name: 'Alloy',
      selector: (row) => row.alloyname,
         sortable: true,
            wrap: true, 
    },
    {
      name: <div title="Temper">T/M</div>,
      selector: (row) => row.temperName,
         sortable: true,
            wrap: true, 
    },
    {
      name: <div title="Weight Range">Wt./R</div>,
      selector: (row) => row.weight,
         sortable: true,
            wrap: true, 
              width:"80px",
    },
    {
      name: 'Length',
      selector: (row) => row.length,
         sortable: true,
            wrap: true, 
         cell: row => {
  const unitOption = goodTypesOptions.find(opt => opt.value === String(row.unit));
  const unitLabel = unitOption ? `(${unitOption.label})` : "";
  return `${row.length ?? ''} ${unitLabel}`;
}
    },
    // {
    //   name: 'Unit',
    //   selector: (row) => {
    //     const unitOption = goodTypesOptions.find((opt) => opt.value === String(row.unit));
    //     return unitOption ? unitOption.label : ''; // e.g., 'MM' or 'Inch'
    //   },
    //      sortable: true,
    // },
    
    {
      name: 'Pcs',
      selector: (row) => row.pcs,
         sortable: true,
            wrap: true, 
              width:"80px",
    },
    {
      name: 'Qty',
      selector: (row) => row.qty,
         sortable: true,
            wrap: true, 
              width:"80px",
    },
    {
      name: 'Customer Name',
      selector: (row) => row.customerName,
         sortable: true,
            wrap: true, 
      width:"200px",
    },
    // {
    //   name: 'Dia No.',
    //   cell: (row) => {
    //     // If diaNumber is 3, show dropdown for selecting either 5 or 7
    //     if (String(row.diaNumber) === '3') {
    //       return (
    //         <Select
    //           placeholder="Select Dia"
              
    //           onChange={(selectedValue) => {
    //             console.log('Selected sub-dia:', selectedValue);
    //             handleDiaSubSelection(selectedValue, row);
    //           }}
    //           optionFilterProp="children"
    //           style={{
    //         width: 100,
    //         border: '2px solid #555', // dark grey border
    //         borderRadius: 4
    //       }}
    //         >
    //           {diaNumberOptions
    //             .filter(opt => opt.value === '1' || opt.value === '2')
    //             .map((opt) => (
    //               <Option key={opt.value} value={opt.value}>
    //                 {opt.label}
    //               </Option>
    //             ))}
    //         </Select>
    //       );
    //     }
    
    //     // Otherwise, just show the mapped label
    //     const diaOption = diaNumberOptions.find((opt) => opt.value === String(row.diaNumber));
    //     return diaOption ? diaOption.label : '';
    //   },
    //      sortable: true,
    // },

    {
  name: 'Dia No.',
  cell: (row) => {
    const isSubDia = rowsWithSubDia.has(row.id) || String(row.diaNumber) === '3';

    if (isSubDia) {
      return (
        <Select
          placeholder="Select Dia"
          // value={String(row.diaNumber)}
            value={['1', '2'].includes(String(row.diaNumber)) ? String(row.diaNumber) : undefined}
          onChange={(selectedValue) => {
            handleDiaSubSelection(selectedValue, row);
          }}
          optionFilterProp="children"
          style={{
            width: 100,
            border: '2px solid #555',
            borderRadius: 4,
          }}
        >
          {diaNumberOptions
            .filter(opt => opt.value === '1' || opt.value === '2')
            .map((opt) => (
              <Option key={opt.value} value={opt.value}>
                {opt.label}
              </Option>
            ))}
        </Select>
      );
    }

    const diaOption = diaNumberOptions.find(
      (opt) => opt.value === String(row.diaNumber)
    );
    return diaOption ? diaOption.label : '';
  },
  sortable: true,
}
,
    // {
    //   name: 'Dia No.',
    //   cell: (row) => (
    //     <Select
    //       placeholder="Select Dia"
    //       style={{ width: 200 }}
    //       value={row.diaNumber} // Handle 0 or null as undefined
    //       onChange={(selectedDiaNumberId) => {
    //         console.log('Selected Dia Number ID:', selectedDiaNumberId) // Log selected diaNumberId
    //         handleDiaChange(selectedDiaNumberId, row)
    //         //handleUpdate(row, selectedDiaNumberId); // Update with selected id
    //       }}
    //       optionFilterProp="children"
    //     >
    //       {diaOptions.map((dia) => (
    //         <Option key={dia.id} value={dia.id}>
    //           {dia.diaNumber}
    //         </Option>
    //       ))}
    //     </Select>
    //   ),

    // },
    // {
    //   name: <div >Press<br />No.</div>,
    //   cell: (row) => (
    //     <Select
    //      placeholder="Select Press"
    //   value={tempPressNumbers[row.id] ?? row.pressNameId ?? undefined}
    //   onChange={(value) => handlePressNumberChange(value, row)}
    //       style={{
    //         width: 120,
    //        // highlight effect
    //         border: '2px solid #555',
    //         borderRadius: 4,
    //       }}
    //     >
    //     {/* <Option value="0"> 0</Option> */}
    //       {pressOptions.map((option) => (
    //         <Option key={option.id} value={option.id}>
    //           {option.pressName}
    //         </Option>
    //       ))}
    //     </Select>
    //   ),
    //   width: '150px',
    //   // Highlight entire column background
    //   style: {
    //     backgroundColor: '#d6f0ff ',
    //   }
    // },
{
  name: <div>Press<br />No.</div>,
  cell: (row) => {
      const effectiveDia = Number(row.diaNumber); 

    // const compatibleOptions = pressOptions.filter((option) =>
    //   option.compatibleDiaNumbers.includes(row.diaNumber)
    // );
     const compatibleOptions = pressOptions.filter((option) =>
      option.compatibleDiaNumbers.includes(effectiveDia)
    );
//console.log("Compatible",compatibleOptions);

    return (
      <Select
        placeholder="Select Press"
        value={tempPressNumbers[row.id] ?? row.pressNameId ?? undefined}
        onChange={(value) => handlePressNumberChange(value, row)}
        style={{
          width: 120,
          border: '2px solid #555',
          borderRadius: 4,
        }}
      >
        {compatibleOptions.length > 0 ? (
          compatibleOptions.map((option) => (
            <Option key={option.id} value={option.id}>
              {option.pressName}
            </Option>
          ))
        ) : (
          <Option disabled>No Press Available</Option>
        )}
      </Select>
    );
  },
  width: '150px',
  style: {
    backgroundColor: '#d6f0ff',
  },
}


,
    {
      name: <div>Prod.<br/> Pcs</div>,
      selector: (row) => renderCommaSeparated(row.productionPcs),
   wrap: true, 
         sortable: true,
          wrap:true,
           width:"80px",
    },
    {
      name: <div>Prod.<br/> Qty</div>,
      selector: (row) =>renderCommaSeparated(row.productionQty),
         sortable: true,
            wrap: true, 
              width:"80px",
    },
    {
      name: <div>Rack <br/>No.</div>,
      selector: (row) => renderCommaSeparated(row.rackNumber),
         sortable: true,
            wrap: true, 
              width:"80px",
    },
     {
      // name: 'Ageging Status',
      name: <div>Ageing<br />Status</div>,
   wrap: true, 
   sortable:true,
      selector: (row) => renderCommaSeparated(row.ageingDescription),
    },
    {
      // name: 'Pending Order Pcs',
      name: <div>Pend. Order<br />Pcs</div>,
      selector: (row) => row.pendingOrderPcs,
         sortable: true,
            wrap: true, 
              width:"80px",
    },
    {
      // name: 'Pending Order Qty',
      name: <div>Pend. Order<br />Qty</div>,
   sortable: true,
      selector: (row) => row.pendingOrderQty,
         wrap: true, 
           width:"80px",
            wrap:true,
    },
   
    {
      // name: 'Packing Pcs',
      name: <div>Pack.<br />Pcs</div>,
      selector: (row) => row.packingPcs,
      width:"80px",
         sortable: true,
          wrap:true,
    },
    {
      // name: 'Packing Qty',
      name: <div>Pack.<br />Qty</div>,
      selector: (row) => row.packingQty,
      width:"80px",
         sortable: true,
          wrap:true,
    },
   


{
  name: <div>Adj.<br />Pcs</div>,
  cell: (row) => (
    <Input
      placeholder="Pcs"
      type="number"
      value={
        tempAdjustmentPcs[row.id] !== undefined
          ? tempAdjustmentPcs[row.id]
          : row.adjustedPcs ?? ''
      }
      onChange={(e) => handleAdjustmentPcsChange(e.target.value, row)}
      style={{
        width: 100,
        border: '2px solid #555',
        borderRadius: 4,
      }}
    />
  ),
  width: '120px',
    style: {
        backgroundColor: '#d6f0ff ',
      }
},
{
  name: <div>Adj.<br />Qty</div>,
  cell: (row) => (
    <Input
      placeholder="Qty"
      type="number"
      value={
        tempAdjustmentQty[row.id] !== undefined
          ? tempAdjustmentQty[row.id]
          : row.adjustedQty ?? ''
      }
      onChange={(e) => handleAdjustmentQtyChange(e.target.value, row)}
      style={{
        width: 100,
        border: '2px solid #555',
        borderRadius: 4,
      }}
    />
  ),
  width: '120px',
    style: {
        backgroundColor: '#d6f0ff ',
      }
},
 
    {
      name: 'Remark',
      cell: (row) => (
        <Input.TextArea
          placeholder="Enter remark"
          value={
            tempRemarks[row.id] !== undefined
              ? tempRemarks[row.id]
              : row.remark ?? ''
          }
          autoSize
          onChange={(e) => handleRemarkChange(e.target.value, row)}
          style={{
        width: 180,
        border: '2px solid #555', // dark grey border
        borderRadius: 4
      }}
        />
      ),
      style: {
        backgroundColor: '#d6f0ff ',
      }
    },
    {
  name: (
    <span>
      Select <br/> All{" "}
      <Checkbox checked={selectAll} onChange={handleSelectAll} />
    </span>
  ),
  cell: (row) => (
    <Checkbox
      checked={approvedItems.has(row.id)}
      onChange={(e) => toggleItemSelection(row.id, e.target.checked)}
    />
  ),
  width: '2%',
   style: {
        backgroundColor: '#d6f0ff ',
      }
},

    {
      name: 'Actions',
      cell: (row) => (
        <div style={{ display: "flex", gap: "8px" }}>
          <Button
            type="primary"
            style={{ fontSize: '12px', marginLeft: '10px' }}
            onClick={() => 
           // handleUpdate(row)
            handleBulkUpdate()}
          >
            Update
          </Button>
          <Button
            type="submit"
            style={{
              fontSize: '12px',
              backgroundColor: 'red',
              color: 'white',
              marginLeft: '10px',
            }}
              onClick={() => handleClose()}
          >
            Close
          </Button>
        </div>
      ),
      width:"200px",
    },
  ]
  const columns2 = [
    {
      name: 'Sr.No.',
      selector: (row, index) => (currentPage - 1) * pageSize + index + 1,
            width: '80px',

    },
    {
  name: <div>Pending Order<br />ID</div>,
        selector: (row) => row.pendingOrder,
      sortable: true,
         wrap: true, 
    },
    {
      name: 'Order No.',
      selector: (row) => row.orderNumber,
      sortable: true,
         wrap: true, 
    },
    {
      name: <div>Item <br/> Name</div>,
      selector: (row) => row.dieName,
      sortable: true,
         wrap: true, 
    },
    {
      name: 'Alloy',
      selector: (row) => row.alloyname,
         sortable: true,
            wrap: true, 
    },
    {
      name: <div title="Temper">T/M</div>,
      selector: (row) => row.temperName,
      
         sortable: true,
            wrap: true, 
    },
    {
      name: <div title="Weight Range">Wt./R</div>,
      selector: (row) => row.weight,
         sortable: true,
           width:"80px",
            wrap:true,
    },
    {
      name: 'Length',
      selector: (row) => row.length,
         sortable: true,
            wrap: true, 
            cell: row => {
  const unitOption = goodTypesOptions.find(opt => opt.value === String(row.unit));
  const unitLabel = unitOption ? `(${unitOption.label})` : "";
  return `${row.length ?? ''} ${unitLabel}`;
}

    },
    // {
    //   name: 'Unit',
    //   selector: (row) => {
    //     const unitOption = goodTypesOptions.find((opt) => opt.value === String(row.unit));
    //     return unitOption ? unitOption.label : ''; // e.g., 'MM' or 'Inch'
    //   },
    //      sortable: true,
    // },

    {
      name: 'Pcs',
      selector: (row) => row.pcs,
         sortable: true,
          wrap:true,
           width:"80px",
    },
    {
      name: 'Qty',
      selector: (row) => row.qty,
         sortable: true,
           width:"80px",
            wrap:true,
    },
    {
      name: 'Customer Name',
      selector: (row) => row.customerName,
      width:"200px",
         sortable: true,
            wrap: true, 
    },
    {
      name: 'Dia No.',
      cell: (row) => row.diaNumber,
         sortable: true,
          wrap:true,
    },
  {
    name:'Press No.',
    cell:(row)=>row.pressName,
    sortable:true,
     wrap:true,

  },
    {
      name: <div>Prod.<br/> Pcs</div>,
      selector: (row) => renderCommaSeparated(row.productionPcs),
         sortable: true,
            width:"80px",
             wrap:true,
    },
    {
      name: <div>Prod.<br/> Qty</div>,
      selector: (row) =>renderCommaSeparated(row.productionQty),
         sortable: true,
            width:"80px",
             wrap:true,
    },
    {
      name: <div>Rack<br/> No.</div>,
      selector: (row) => renderCommaSeparated(row.rackNumber),
         sortable: true,
          wrap:true,
    },
    {
         name: <div>Ageing  <br/> Status</div>,
      selector: (row) => renderCommaSeparated(row.ageingDescription),
         sortable: true,
         wrap:true,
    },
    {
       name: <div>Pend. Order<br />Pcs</div>,
      selector: (row) => row.pendingOrderPcs,
         sortable: true,
            width:"80px",
             wrap:true,
    },
    {
        name: <div>Pend. Order<br />Qty</div>,
      selector: (row) => row.pendingOrderQty,
         sortable: true,
            width:"80px",
             wrap:true,
    },
    
    {
         name: <div>Pack.<br />Pcs</div>,
      selector: (row) => row.packingPcs,
         sortable: true,
            width:"80px",
             wrap:true,
    },
    {
         name: <div>Pack.<br />Qty</div>,
      selector: (row) => row.packingQty,
         sortable: true,
            width:"80px",
             wrap:true,
    },
    {
      name: 'Remark',
      cell: (row) => row.remark,
         sortable: true,
         wrap: true, 
    },
      {
      name: <div>Closing  <br/> Status</div>,
      cell: (row) => row.isClosed,
         sortable: true,
            wrap: true, 
      
    },
  
  ]
  // const components = {
  //   header: {
  //     cell: ({ children, ...restProps }) => (
  //       <th
  //         {...restProps}
  //         style={{
  //           backgroundColor: '#023e7d',
  //           color: '#fff',
  //           padding: '10px',
  //           fontSize: '13px',
  //           borderRadius: '0px',
  //         }}
  //       >
  //         {children}
  //       </th>
  //     ),
  //   },
  //   body: {
  //     row: ({ children, ...restProps }) => (
  //       <tr
  //         {...restProps}
  //         style={{
  //           backgroundColor: '#f0f7fd',
  //         }}
  //       >
  //         {children}
  //       </tr>
  //     ),
  //     cell: ({ children, ...restProps }) => (
  //       <td
  //         {...restProps}
  //         style={{
  //           padding: '8px',
  //         }}
  //       >
  //         {children}
  //       </td>
  //     ),
  //   },
  // }

  const renderCommaSeparated = (value) => {
    return value?.split(',').map((v, i) => <div key={i}>{v.trim()}</div>);
  };
  // const [showAddForm, setShowAddForm] = useState(false);

  // useEffect(() => {
  //   const Length = parseFloat(length);
  //   const range = parseFloat(weightRange);
  //   const pcsCount = parseFloat(Pcs);

  //   if (!isNaN(Length) && !isNaN(range) && !isNaN(pcsCount)) {
  //     let calculatedQty = 0;

  //     if (unit == '1') {
  //       calculatedQty = range * (Length / 12) * pcsCount;
  //     } else if (unit == '2') {
  //       calculatedQty = range * (Length / 360) * pcsCount;
  //     } else if (unit == '3') {
  //       calculatedQty = range * (Length / 144) * pcsCount;
  //     }

  //     // Round to 2 decimal places if needed
  //     setQty(calculatedQty.toFixed(2));
  //   } else {
  //     setQty(""); // Clear if input is invalid
  //   }
  // }, [unit, weightRange, length, Pcs]);

  // const handleCancel = () =>{
  //   setShowAddForm(false);
  //  setAlloy("");
  //  setLength("");
  //  setItemName("");
  //  setCustomerName("");
  //  setTemper("");
  //  setQty("");
  //  setPcs("");
  //  setUnit("");
  //  setWeightRange("");
  // //  setStockId("");
  // }
  // Submit to API
  // const handleAddPendingOrder = async () => {
  //   let isValid = true;
  //   const errorObj = {};

  //   if (!stockId) {
  //     isValid = false;
  //     errorObj.stockId = "Order Number is required *";
  //   }
  //   if (!alloy) {
  //     isValid = false;
  //     errorObj.alloy = "Alloy is required *";
  //   }
  //   if (!length) {
  //     isValid = false;
  //     errorObj.length = "Length is required *";
  //   }

  //   if (!itemName) {
  //     isValid = false;
  //     errorObj.itemName = "Item Name is required *";
  //   }
  //   if (!temper) {
  //     isValid = false;
  //     errorObj.temper = "Temper is required *";
  //   }
  //   if (!Pcs) {
  //     isValid = false;
  //     errorObj.Pcs = "Pcs is required *";
  //   }

  //   if (!unit) {
  //     isValid = false;
  //     errorObj.unit = "Unit is required *";
  //   }
  //   if (!weightRange) {
  //     isValid = false;
  //     errorObj.weightRange = "Weight Range is required *";
  //   }
  //   if (!Qty) {
  //     isValid = false;
  //     errorObj.Qty = "Quantity is required *";
  //   }
  //   if (!customerName) {
  //     isValid = false;
  //     errorObj.customerName = "Customer Name is required *";
  //   }

  //   setErrors(errorObj); // Set error messages

  //   if (!isValid) return;
  //  const bodyData={
  //   dieNumberId: itemName,
  //   alloyId: alloy,
  //   temperId: temper,
  //   wtRange:weightRange,
  //   length:length,
  //   pcs: Pcs,
  //   qty: Qty,
  //   customerId: customerName,
  //   stockNumber: stockId,
  //   unit: unit,

  //  };
  //   try {
  //      const response = await axios.post(SavePendingOrder,bodyData,commonHeaders);

  //     if (response.status === 200 || response.data === "CREATED") {
  //       toast.success("Pending order added successfully!");
  // //fetchData(); // Re-fetch table data
  //       setShowAddForm(false);
  //       handleCancel();

  //     }
  //   } catch (error) {
  //     toast.error("Failed to add pending order");
  //     console.error(error);
  //   }
  // };
// const handleClose = async (row) => {
//   let idsArray = [];

//   if (row) {
//     // If a single row is passed, close only that order
//     idsArray = [row.id];
//   } else {
//     // Bulk close: collect all selected item IDs
//     idsArray = Array.from(approvedItems);
//     if (idsArray.length === 0) {
//       toast.warning('Please select at least one item to close.');
//       return;
//     }
//   }

//   try {
//     const response = await axios.put(
//       'http://192.168.29.116:8182/pendingOrder/updateIsCloseStatus',
//       // Send ids in the request body, not as URL params
//       { ids: idsArray }
//     );

//     if (response.status === 200) {
//       toast.success(`${row ? 'Order' : 'Selected orders'} closed successfully!`);
//       fetchPendingSummary();
//     } else {
//       toast.error('Failed to close order(s).');
//     }
//   } catch (error) {
//     console.error('Error closing order(s):', error);
//     toast.error('Error closing order(s).');
//   }
// };
const handleClose = async (row) => {
  let idsArray = [];

  if (row) {
    // If a single row is passed, close only that order
    idsArray = [row.id];
  } else {
    // Bulk close: collect all selected item IDs
    idsArray = Array.from(approvedItems);
    if (idsArray.length === 0) {
      toast.warning('Please select at least one item to close.');
      return;
    }
  }

  // Log idsArray to check for null/undefined values
  console.log("IDs to close:", idsArray);

  // Ensure all IDs are valid (i.e., numbers)
  idsArray = idsArray.filter(id => id != null && !isNaN(id));

  if (idsArray.length === 0) {
    toast.error('No valid IDs selected.');
    return;
  }

  try {
    const response = await axios.put(
      ClosePendingOrder,
      { ids: idsArray } ,commonHeaders// Send ids in the request body
    );

    if (response.status === 200) {
      toast.success(`${row ? 'Order' : 'Selected orders'} closed successfully!`);
      fetchPendingSummary();
    } else {
      toast.error('Failed to close order(s).');
    }
  } catch (error) {
    console.error('Error closing order(s):', error);
    toast.error('Error closing order(s).');
  }
};
const handleDateChange = (date, dateString) => {
  setSelectedDate(dateString);
  if (dateString) {
    fetchPendingHistory(dateString);
  }
};


  return (
    <div className="px-5 py-3" style={{ fontSize: "15px" }}>



    <div className="p-0 m-0">
      {/* <div className="row px-md-5 mt-3 p-2" >
        <div className="col-12 col-lg-3"></div>

        {/* Inline Add Pending Order Form 
{showAddForm && (

    <div className="col-12 col-lg-6">
      <div className="row p-0 m-0 border p-3 rounded" >
        <h6 className="mb-3 text-center">Add New Pending Order</h6>

        <div className="row">
        <div className="col-md-6 mb-3"> 
                  <label className="labels">Stock Id</label>
          <Input
            type="text"
            value={stockId}
            onChange={(e) =>
              setStockId( e.target.value)
            }
            placeholder="Enter Stock Id"
            style={{ width: '100%' }}
          />
            {errors.stockId && (
                           <div className="errorField">{errors.stockId}</div>
                         )}
        </div>

        <div className="col-md-6 mb-3">
          <label className="labels">Item Name</label>
          <Select
                           value={itemName || undefined}
                           onChange={setItemName}
                           showSearch
                           className="w-100"
                           placeholder="Select Name"
                           optionFilterProp="children"
                         >
                           {allItems.map((item) => (
                             <Option key={item.id} value={item.id}>
                               {item.dieName}
                             </Option>
                           ))}
                         </Select>
                         {errors.itemName && (
                           <div className="errorField">{errors.itemName}</div>
                         )}
        </div>
  </div>
  <div className="row">
        <div className="col-md-6 mb-3">          
        <label className="labels">Alloy</label>
                      <Select
                        value={alloy || undefined}
                        onChange={setAlloy}
                        showSearch
                        className="w-100"
                        placeholder="Select Name"
                        optionFilterProp="children"
                      >
                        {allAlloy.map((alloy) => (
                          <Option key={alloy.id} value={alloy.id}>
                            {alloy.alloyName}
                          </Option>
                        ))}
                      </Select>
                      {errors.alloy && (
                        <div className="errorField">{errors.alloy}</div>
                      )}
        </div>

        <div className="col-md-6 mb-3"> 
                   <label className="labels">Temper</label>
                                     <Select
                                         value={temper || undefined}
                                         onChange={setTemper}
                                         showSearch
                                         className="w-100"
                                         placeholder="Select Temper"
                                         optionFilterProp="children"
                                       >
                                         {allTemper.map((temper) => (
                                           <Option key={temper.id} value={temper.id}>
                                             {temper.temperName}
                                           </Option>
                                         ))}
                                       </Select>
                                     {errors.temper && (
                                       <div className="errorField">{errors.temper}</div>
                                     )}
        </div></div>

        <div className="row">
        <div className="col-md-6 mb-3"> 
                  <label className="labels">Customer Name</label>
                        <Select
                          value={customerName || undefined}
                          onChange={setCustomerName}
                          showSearch
                          className="w-100"
                          placeholder="Select Name"
                          optionFilterProp="children"
                        >
                          {allCustomers.map((customer) => (
                            <Option key={customer.id} value={customer.id}>
                              {customer.customerName}
                            </Option>
                          ))}
                        </Select>
                        {errors.customerName && (
                          <div className="errorField">{errors.customerName}</div>
                        )}
        </div>
        <div className="col-md-6 mb-3"> 
                  <label className="labels">Pcs</label>
          <Input
            type="number"
            value={Pcs}
            onChange={(e) =>
              setPcs( e.target.value )
            }
            placeholder="Enter Pcs"
            style={{ width: '100%' }}
          />
            {errors.Pcs && (
                          <div className="errorField">{errors.Pcs}</div>
                        )}
        </div></div>
        <div className="row">
        <div className="col-md-6 mb-3"> 
                  <label className="labels">Qty</label>
          <Input
            type="number"
            value={Qty}
            onChange={(e) =>
              setQty( e.target.value )
            }
            placeholder="Enter Quantity"
            style={{ width: '100%' }}
          />
            {errors.Qty && (
                          <div className="errorField">{errors.Qty}</div>
                        )}
        </div>
        <div className="col-md-6 mb-3"> 
                  <label className="labels">Weight Range</label>
          <Input
            type="number"
            value={weightRange}
            onChange={(e) =>
              setWeightRange( e.target.value )
            }
            placeholder="Enter Weight Range"
            style={{ width: '100%' }}
          />
            {errors.weightRange && (
                          <div className="errorField">{errors.weightRange}</div>
                        )}
        </div></div>
        <div className="row">
        <div className="col-md-6 mb-3"> 
                  <label className="labels">Length</label>
          <Input
            type="number"
            value={length}
            onChange={(e) =>
              setLength( e.target.value )
            }
            placeholder="Enter Length"
            style={{ width: '100%' }}
          />
            {errors.length && (
                          <div className="errorField">{errors.length}</div>
                        )}
        </div>
        <div className="col-md-6 mb-3"> 
                  <label className="labels">Unit</label>
                                      <Select
                                        value={unit || undefined}
                                        onChange={setUnit}
                                        showSearch
                                        className="w-100"
                                        placeholder="Select Unit"
                                        optionFilterProp="children"
                                      >
                                        {goodTypesOptions.map((opt) => (
                                          <Option key={opt.value} value={opt.value}>
                                            {opt.label}
                                          </Option>
                                        ))}
                                      </Select>
                                      {errors.unit && (
                                        <div className="errorField">{errors.unit}</div>
                                      )}
        </div></div>
       
        
        <div className="col-12 text-center pt-3">
          <Button
            type="default"
            className="CancelBtn mx-1"
            onClick={() => {
            handleCancel();
            }}
          >
            Cancel
          </Button>
          <Button
            type="primary"
            className="SubmitBtn mx-1"
            onClick={handleAddPendingOrder}
          >
            Save
          </Button>
        </div>
      </div>
    </div>

)}
      </div> */}

      <div className="col-12 col-lg-4"></div>

      <div className="col-12 p-0 mt-3"></div>
      <div  className="row mt-3 p-3 pb-5 pt-3 mb-3 rounded" style={{ backgroundColor: '#e0efff' }}>
          
          <div className="col-12">
      {/*================ Table =========================*/}
      
      {/* <h5><u>Pending Order Summary   </u> -{' '}</h5> */}
        <div
          className="col-12 py-3 shadow border"
          style={{  backgroundColor: 'white' }}
        >
          <div
            className="col-12 px-md-5"
            style={{ display: 'flex', justifyContent: 'space-between' }}
          >
            <div>
              {/* <span style={{ fontSize: '14px' }}>Show entries &nbsp;</span>
              <Select
                defaultValue={pageSize}
                // onChange={handlePageSizeChange}
                onChange={(value) => {
    setPageSize(value);
    setCurrentPage(1);
  }}
                style={{ width: 120, textAlign: 'center' }}
              >
                <Option value={10}>10</Option>
                <Option value={20}>20</Option>
                <Option value={30}>30</Option>
              </Select> */}
        </div>

            <div className="pt-4 pt-md-0" style={{ display: 'flex', gap: '5%' }}>
              {/* Button to show Add Order form */}
              {/* {!showAddForm && (
             <Button
    type="primary"
    icon={<PlusOutlined />}
    onClick={() => setShowAddForm(true)}
          >
           Add New Pending Order
  </Button>
)} */}
              {/* <Input.Search
             
                placeholder="Search"
                onSearch={handleSearch}
                style={{ width: 200, marginBottom: 16 }}
              /> */}
               {approvedItems.size > 1 && (
  <div style={{ display: 'flex',gap:'5%', marginBottom: '10px' }}>
    <Button
      type="primary"
      danger
      onClick={() => handleClose()} // Bulk close
    >
      Bulk Close Selected
    </Button>

    <Button
      type="primary"
      onClick={() => handleBulkUpdate()} // Bulk update
    >
      Bulk Update
    </Button>
  </div>
)}

              <Input.Search
  placeholder="Search"
  value={searchValue}
  allowClear
  onChange={(e) => handleSearch(e.target.value)}
  onSearch={handleSearch}
  style={{ width: 200, marginBottom: 16 }}
/>

            </div>
          </div>

          <div style={{ backgroundColor: 'white',padding: '1% 1%' }}>
            {/* <Table
                      bordered
                      style={{ padding: "0px 20px", overflowX: "auto" }}
                      columns1={columns1}
                      dataSource={filteredData}
                     pagination={{
    current: currentPage,
    pageSize,
    onChange: (page) => setCurrentPage(page),
  }}
                      showSorterTooltip={false}
                      rowKey={(record) => record.id}
                      components={components}
                    /> */}
          <div style={{ overflowX: 'auto'}}>
  
            <DataTable
  
  //data={pendingOrderData}    // use the state that updates
  columns={columns1}
  data={searchValue ? filteredData : pendingOrderData} // full data
  striped
  
  responsive
   pagination
  paginationPerPage={pageSize}
  paginationResetDefaultPage={true}
  paginationRowsPerPageOptions={[10, 20, 30]} // this is important
  onChangeRowsPerPage={(newPageSize, page) => {
    setPageSize(newPageSize);
    setCurrentPage(page); // update page to current (or reset to 1 if you want)
  }}
  onChangePage={(page) => setCurrentPage(page)}
  paginationDefaultPage={currentPage}
  // paginationPerPage={pageSize}
  // paginationDefaultPage={currentPage}
  // onChangeRowsPerPage={handlePageSizeChange}
  paginationComponentOptions={{
    rowsPerPageText: "Rows per page:",
    rangeSeparatorText: "of",
    noRowsPerPage: false,
  }}

  // onChangeRowsPerPage={(newPageSize) => {
  //   setPageSize(newPageSize);
  //   setCurrentPage(1);
  // }}
 
    customStyles={{
    headCells: {
    style: {
      backgroundColor: '#023e7d',
      color: '#fff',
      padding: '10px',
      fontSize: '14px',
      borderRadius: '0px',
    },
  },
  rows: {
    style: {
      backgroundColor: '#f0f7fd',
      minHeight: '48px', // optional
    },
  },
  cells: {
    style: {
      padding: '8px',
      fontSize:'14px',
    },
  },
  }}
/>
</div>

          </div>
        </div>

      
      </div>
      </div>
      <div  className="row mt-3 p-3 pb-5 pt-3  mb-3 rounded" style={{ backgroundColor: '#e0efff' }}>
          
          <div className="col-12">
      
      <h5><u>Pending Order History  </u>  -{' '}</h5>
        
             <div className="row align-items-center mb-3">
      <div className="col-md-3 offset-md-1">
        <label className="labels">Select Date</label>
        <DatePicker
          onChange={handleDateChange}
          format="YYYY-MM-DD"
          placeholder="Select Date"
          className="w-100"
        />
      </div>

      {/* Optional: Uncomment this for a 'View' button */}
      {/* <div className="col-md-2">
        <Button type="primary" onClick={handleViewData}>
          View
        </Button>
      </div> */}
    </div>
          
        <div
          className="col-12 py-3 shadow border"
          style={{  backgroundColor: 'white' }}
        >
          <div
            className="col-12 px-md-5"
            style={{ display: 'flex', justifyContent: 'space-between' }}
          >
            <div>
               {/*  <span style={{ fontSize: '14px' }}>Show entries &nbsp;</span>
            <Select
                defaultValue={pageSize}
                onChange={handlePageSizeChange}
                style={{ width: 120, textAlign: 'center' }}
              >
                <Option value={10}>10</Option>
                <Option value={20}>20</Option>
                <Option value={30}>30</Option>
              </Select> */}
            </div>

            <div className="pt-4 pt-md-0" style={{ gap: '40px' }}>
      
 
              <Input.Search
  placeholder="Search"
  value={searchValue1}
  allowClear
  onChange={(e) => handleSearch1(e.target.value)}
  onSearch={handleSearch1}
  style={{ width: 200, marginBottom: 16 }}
/>
            </div>
          </div>

          <div style={{ backgroundColor: 'white', padding: '1% 1%'  }}>
           
          
            <DataTable
            showGridlines 
  columns={columns2}
  data={searchValue1 ? filteredData1 : pendingOrderHistory}    // use the state that updates
 
  responsive
 pagination
  paginationPerPage={pageSize1}
  paginationResetDefaultPage={true}
  paginationRowsPerPageOptions={[10, 20, 30]} // this is important
  onChangeRowsPerPage={(newPageSize, page) => {
    setPageSize1(newPageSize);
    setCurrentPage1(page); // update page to current (or reset to 1 if you want)
  }}
  onChangePage={(page) => setCurrentPage1(page)}
  paginationDefaultPage={currentPage1}
   paginationComponentOptions={{
    rowsPerPageText: "Rows per page:",
    rangeSeparatorText: "of",
    noRowsPerPage: false,
  }}
  // onChangeRowsPerPage={handlePageSizeChange}
  // // components={components}
  customStyles={{
    headCells: {
    style: {
      backgroundColor: '#023e7d',
      color: '#fff',
      padding: '10px',
      fontSize: '14px',
      borderRadius: '0px',
    },
  },
  rows: {
    style: {
      backgroundColor: '#f0f7fd',
      minHeight: '48px', // optional
    },
  },
  cells: {
    style: {
      padding: '8px',
                  fontSize: '14px',
    },
  },
  }}
/>

          </div>
        </div>

      

    </div>
    </div>
    </div>
    </div>
  )
}

export default PendingOrderSummary
